import { AppState } from '../models/app-state'
import { createSelector, createFeatureSelector } from '@ngrx/store'
import { AuthModel, authFeatureKey, getAuthSelectors } from 'ng-client-auth'
import { Permissions } from '@exchange/app/domain'
import { environment } from '@exchange/environment'
import { MenusComponentModel } from '@exchange/app/ui/shared/menus/menus.component'
import { HeaderComponentModel } from '@exchange/app/ui/shared/header/header.component'
import { AppComponentModel } from '@exchange/app/app.component'

export const selectAuthFeature = createFeatureSelector<AppState, AuthModel>(authFeatureKey)

const { selectIsAuthenticated, selectUserPermissions, selectUserName } = getAuthSelectors(
  selectAuthFeature
)

export const selectMenuModel = createSelector(
  selectUserPermissions,
  selectUserName,
  selectIsAuthenticated,
  (permissions, username, isAuthenticated): MenusComponentModel => {
    return {
      username,
      isAuthenticated,
      isPatientManagmentMenuAvailable:
        permissions.includes(Permissions.PatientManagement) ||
        permissions.includes(Permissions.PatientViewAll),
      isSystemManagementMenuAvailable: permissions.includes(Permissions.SystemManagement),
      isFacilitiesOrAgenciesMenuAvailable:
        permissions.includes(Permissions.SystemManagement) ||
        permissions.includes(Permissions.CreateEditAnchorProviders),
      isTransactionManagementMenuAvailable: permissions.includes(Permissions.TransactionManagement),
      isAllUserManagementMenuAvailable: permissions.includes(Permissions.UserManagement),
      isUserManagementMenuAvailable:
        permissions.includes(Permissions.AddEditProviderUser) ||
        permissions.includes(Permissions.UserManagement),
      isAdministrationMenuAvailable:
        permissions.includes(Permissions.UserManagement) ||
        permissions.includes(Permissions.AddEditProviderUser),
      isUploaderToolMenuAvailable: permissions.includes(Permissions.UploaderTool),
      patientManagementUrl: environment.pmroot,
      caseloadUrl: environment.caseloadUrl,
      isCaseloadAvailable: permissions.includes(Permissions.ViewCaseload)
    }
  }
)

export const selectHeaderModel = createSelector(
  selectMenuModel,
  (menuModel): HeaderComponentModel => ({
    menu: menuModel
  })
)

export const selectAppComponentModel = createSelector(
  selectHeaderModel,
  selectIsAuthenticated,
  (headerModel, isAuthenticated): AppComponentModel => {
    return {
      header: headerModel,
      isAuthenticated
    }
  }
)

export interface BasicUserPermissionsComponentModel {
  userPermissions: number[]
}

export const selectBasicUserPermissionsComponentModel = createSelector(
  selectUserPermissions,
  (permissions): BasicUserPermissionsComponentModel => ({
    userPermissions: permissions
  })
)
